export const environment = {
	 baseUrl: "https://api.tickets.zimo.one"
}
